import { BookingFlow } from '@beatgig/gql'
import useEnumFilter from '@beatgig/search/filters/enum/use-enum-filter'

export function useBookingFlowFilter() {
  return useEnumFilter(BookingFlow, 'booking_flow', {
    persistKey: 'booking-flow',
    title: 'Booking Flow',
  })
}
